export default __webpack_public_path__ + "static/media/hero_bg_lg.93200f3e.png";